import gql from 'graphql-tag';

export const parentIntegrationItemFacetFragment = gql`
  fragment parentIntegrationItemFacetFragment on ParentIntegrationItemFacet {
    dokkioClass
    count
    integrationID
    remoteID
    integrationItem {
      integrationID
      remoteID
      dokkioClass
      name
      parentPaths
    }
  }
`;
export default parentIntegrationItemFacetFragment;
